import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddressPipe } from './address.pipe';

@NgModule({
  declarations: [
    AddressPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AddressPipe
  ]
})
export class AddressPipeModule { }
